/**
 * A student's work as the pages the analysis read: each page on its own, one
 * under another, labelled "Page i of N". One image when there is one.
 *
 * A joined image of the pages adds nothing for a student or teacher, and the
 * model never read one. See
 * docs/FeatureDesigns/solution-analysis/student-work-pages-target.md §6.
 */
import { ImageViewer } from './ImageViewer';
import './StudentWorkImages.css';

interface StudentWorkImagesProps {
  /** The one image, used when there are no pages. */
  imageUrl?: string;
  /** The pages, in reading order, when the work spans more than one. */
  pageUrls?: string[];
  alt?: string;
  className?: string;
}

export function StudentWorkImages({ imageUrl, pageUrls, alt = 'Work', className }: StudentWorkImagesProps) {
  if (pageUrls && pageUrls.length > 1) {
    return (
      <div className="student-work-pages">
        {pageUrls.map((url, i) => (
          <figure key={`${url}-${i}`} className="student-work-page">
            <ImageViewer src={url} alt={`${alt}, page ${i + 1} of ${pageUrls.length}`} className={className} />
            <figcaption>Page {i + 1} of {pageUrls.length}</figcaption>
          </figure>
        ))}
      </div>
    );
  }
  return imageUrl ? <ImageViewer src={imageUrl} alt={alt} className={className} /> : null;
}
